import { Button } from '@/components/ui/button';
import { ChartLine } from '@phosphor-icons/react';

const NavLinks = () => (
  <>
    <a href="#problem" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors">Problem</a>
    <a href="#framework" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors">Framework</a>
    <a href="#pricing" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors">Pricing</a>
    <a href="#contact" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors">Contact</a>
  </>
);

const NavBar = ({ onAdminLogin }) => (
  <nav className="sticky top-0 z-50 backdrop-blur-xl bg-white/85 border-b border-slate-200/60">
    <div className="max-w-7xl mx-auto px-6 lg:px-12 py-4 flex items-center justify-between">
      <a href="#top" className="flex items-center gap-3 group">
        <div className="w-10 h-10 bg-gradient-to-br from-slate-900 to-teal-600 rounded-lg flex items-center justify-center">
          <ChartLine size={22} weight="bold" className="text-white" />
        </div>
        <div>
          <div className="text-base font-bold tracking-tight text-slate-900 leading-none">AWSAI</div>
          <div className="text-[10px] tracking-[0.18em] uppercase font-semibold text-teal-700 mt-0.5">
            Workflow & AI Readiness Diagnostic
          </div>
        </div>
      </a>
      <div className="hidden md:flex items-center gap-7">
        <NavLinks />
        <Button
          data-testid="admin-login-nav-button"
          onClick={onAdminLogin}
          variant="outline"
          className="border-2 border-slate-900 text-slate-900"
        >
          Admin Login
        </Button>
      </div>
    </div>
  </nav>
);

export default NavBar;
